const calendarData = [
  {
    year: "2025",
    stage: "Prelims",
    notification: "22 January 2025",
    lastDate: "11 February 2025",
    exam: "25 May 2025 (Sunday)",
  },
  {
    year: "2025",
    stage: "Mains",
    notification: "—",
    lastDate: "—",
    exam: "22–31 August 2025 (5 days)",
  },
  {
    year: "2026",
    stage: "Prelims",
    notification: "14 January 2026",
    lastDate: "3 February 2026",
    exam: "24 May 2026 (Sunday)",
  },
  {
    year: "2026",
    stage: "Mains",
    notification: "—",
    lastDate: "—",
    exam: "Begins 21 August 2026 (5 days)",
  },
];

export default calendarData;
